import { gql } from '@apollo/client';

export const GET_MEMBERSHIP_INFO = gql`
  query GET_MEMBERSHIP_INFO {
    currentMember {
      firstName
      lastName
      lastLocation {
        latitude
        longitude
      }
      memberStatus
      subscriptionStatus
      primaryCode {
        code
      }
      startDate
      subscriptionInfo {
        hasRecurlyAccount
        creditCardType
        creditCardHint
        finalPaymentDate
        paymentAmount
        paymentType
        nextPaymentDate
        finalAccessDate
        requestedChangeDate
        requestedChangeTier {
          name
          benefits
          imageUrl
          tierId
          monthlyFee
        }
      }
      effectiveTier {
        name
        benefits
        imageUrl
        tierId
        monthlyFee
      }
      isPrimaryMemberAnnualFeePaid
    }
  }
`;

export const CANCEL_MEMBERSHIP = gql`
  mutation CANCEL_MEMBERSHIP($surveyAnswers: [SurveyAnswer]) {
    cancelMembership(surveyAnswers: $surveyAnswers) {
      rallyId
      subscriptionStatus
    }
  }
`;

export const CANCEL_MEMBERSHIP_CANCELLATION_API = gql`
  mutation CANCEL_MEMBERSHIP_CANCELLATION_API(
    $reasonsWithDetails: [CancellationReasonWithDetail]
  ) {
    cancelMembershipCancellationAPI(reasonsWithDetails: $reasonsWithDetails) {
      rallyId
      subscriptionStatus
    }
  }
`;

export const SEND_PRIMARY_ENROLL_EMAIL = gql`
  mutation SEND_PRIMARY_ENROLL_EMAIL(
    $tierId: String!
    $email: String!
    $isPromotionalCommunicationsAccepted: Boolean
  ) {
    sendPrimaryEnrollEmail(
      tierId: $tierId
      email: $email
      isPromotionalCommunicationsAccepted: $isPromotionalCommunicationsAccepted
    )
  }
`;
